import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertLevel, AlertsService } from '../common/alerts/alerts.service';
import { Router } from '@angular/router';

const HTTP_UNAUTH_CODE = 401;
const HTTP_FORBIDDEN_CODE = 403;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private readonly authService: AuthService,
                private readonly alertsService: AlertsService,
                private readonly router: Router) {}

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError(err => {
            if (err.status === HTTP_UNAUTH_CODE && !err.url.endsWith('login')) {
                this.authService.logout();
            } else if (err.status === HTTP_FORBIDDEN_CODE && !err.url.endsWith('login')) {
                this.router.navigate(['/']).then(() => {
                    this.alertsService.alert(err.error.message, AlertLevel.InfoFailure);
                });
            }

            return throwError(err);
        }));
    }

}
